define('services/mandatory-questionnaires',[
    'backbone', 'underscore',
    // events
    'services/events/questionnaire-events',
    // views
    'views/modules/questionnaire/modal/questionnaire-modal'

], function(
    Backbone, _,
    // events
    QuestionnaireEvents,
    // views
    VQuestionnaireModal
) {

    var MandatoryQuestionnaires = Backbone.View.extend({
        initialize: function(opt) {
            _.extend(this, opt);
            this.questionnairesIndex = 0;

            this.listenTo(QuestionnaireEvents, "questionnaire:saved", this.start);
        },

        start: function() {
            if (this.questionnaires.length <= this.questionnairesIndex) {
                this.questionnairesIndex = 0;
                return;
            }
            new VQuestionnaireModal({ questionnaire: this.questionnaires[this.questionnairesIndex].toString() });
            this.questionnairesIndex++;
        }
    });

    return MandatoryQuestionnaires;
});

